import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

export default function InfoDialog({ open, setOpen, title, info, onClose, className = ''}) {
  const handleClose = () => {
    setOpen(false);
    onClose(true);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      className="payment-modal"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogActions>
        <IconButton
          aria-label="close"
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogActions>
      <DialogTitle className="info-title">{title}</DialogTitle>
      <DialogContent className={className}>{info}</DialogContent>
    </Dialog>
  );
}